import type { HttpErrorResponse } from '@angular/common/http';

import { createAction, props } from '@ngrx/store';

import type { Position } from '@core/http-types';
import type { TalentPoolData, TalentPoolFull } from '@core/talent-pools-types';

const namespace = 'TalentPools';

const getActionType = (name: string) => `[${namespace}] ${name}`;

const actions = {
  follow: createAction(getActionType('follow'), props<{ payload: { id: number } }>()),
  followSuccess: createAction(getActionType('followSuccess')),
  followFailed: createAction(
    getActionType('followFailed'),
    props<{ payload: { error: HttpErrorResponse } }>(),
  ),

  unfollow: createAction(getActionType('unfollow'), props<{ payload: { id: number } }>()),
  unfollowSuccess: createAction(getActionType('unfollowSuccess')),
  unfollowFailed: createAction(
    getActionType('unfollowFailed'),
    props<{ payload: { error: HttpErrorResponse } }>(),
  ),

  duplicate: createAction(getActionType('duplicate'), props<{ payload: { id: number } }>()),
  duplicateSuccess: createAction(
    getActionType('duplicateSuccess'),
    props<{ payload: { data: TalentPoolFull } }>(),
  ),
  duplicateFailed: createAction(
    getActionType('duplicateFailed'),
    props<{ payload: { error: HttpErrorResponse } }>(),
  ),

  archive: createAction(getActionType('archive'), props<{ payload: { id: number } }>()),
  archiveSuccess: createAction(
    getActionType('archiveSuccess'),
    props<{ payload: { data: TalentPoolFull } }>(),
  ),
  archiveFailed: createAction(
    getActionType('archiveFailed'),
    props<{ payload: { error: HttpErrorResponse } }>(),
  ),

  retrieve: createAction(getActionType('retrieve'), props<{ payload: { id: number } }>()),
  retrieveSuccess: createAction(
    getActionType('retrieveSuccess'),
    props<{ payload: { data: TalentPoolFull } }>(),
  ),
  retrieveFailed: createAction(
    getActionType('retrieveFailed'),
    props<{ payload: { error: HttpErrorResponse } }>(),
  ),

  removeOne: createAction(getActionType('removeOne'), props<{ payload: { id: number } }>()),
  removeOneSuccess: createAction(
    getActionType('removeOneSuccess'),
    props<{ payload: { id: number } }>(),
  ),
  removeOneFailed: createAction(
    getActionType('removeOneFailed'),
    props<{ payload: { error: HttpErrorResponse } }>(),
  ),

  updatePositions: createAction(
    getActionType('updatePositions'),
    props<{ payload: { positions: Position[] } }>(),
  ),
  updatePositionsSuccess: createAction(getActionType('updatePositionsSuccess')),
  updatePositionsFailed: createAction(
    getActionType('updatePositionsFailed'),
    props<{ payload: { error: HttpErrorResponse } }>(),
  ),

  create: createAction(getActionType('create'), props<{ payload: { data: TalentPoolData } }>()),
  createSuccess: createAction(
    getActionType('createSuccess'),
    props<{ payload: { data: TalentPoolFull } }>(),
  ),
  createFailed: createAction(
    getActionType('createFailed'),
    props<{ payload: { error: HttpErrorResponse } }>(),
  ),

  update: createAction(
    getActionType('update'),
    props<{ payload: { data: TalentPoolData & { id: number } } }>(),
  ),
  updateSuccess: createAction(
    getActionType('updateSuccess'),
    props<{ payload: { data: TalentPoolFull } }>(),
  ),
  updateFailed: createAction(
    getActionType('updateFailed'),
    props<{ payload: { error: HttpErrorResponse } }>(),
  ),
};

export { actions as TalentPoolsActions };
